import(/* webpackMode: "eager" */ "C:\\dev\\cfs-website\\next\\app\\globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "C:\\dev\\cfs-website\\next\\components\\FloatingContactButton.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "C:\\dev\\cfs-website\\next\\components\\Footer.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "C:\\dev\\cfs-website\\next\\components\\Header.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "C:\\dev\\cfs-website\\next\\components\\HolidayBanner.js");
;
import(/* webpackMode: "eager" */ "C:\\dev\\cfs-website\\next\\node_modules\\next\\dist\\client\\script.js");
;
import(/* webpackMode: "eager" */ "C:\\dev\\cfs-website\\next\\node_modules\\next\\font\\google\\target.css?{\"path\":\"app\\\\layout.tsx\",\"import\":\"Inter\",\"arguments\":[{\"subsets\":[\"latin\"],\"variable\":\"--font-inter\",\"display\":\"swap\"}],\"variableName\":\"inter\"}");
